import { HashRouter } from "react-router-dom";
import { GeneralRoutes } from "./routes/GeneralRoutes";
import "./i18n/config";

function App() {
    return (
        <HashRouter>
            <GeneralRoutes></GeneralRoutes>
        </HashRouter>
    );
}

export default App;
